exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-form .el-input[data-v-6740d228],.el-select[data-v-6740d228]{width:180px}\n", ""]);

// exports
